/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import Subscription from '@/models/myProfile/Subscription';
import Payment from '@/models/myProfile/Payment';
import PaymentInfo from '@/models/myProfile/PaymentInfo';
import SiteLicense from '@/models/myProfile/SiteLicense';
import SiteLicenseUser from '@/models/myProfile/SiteLicenseUser';
import Gift from '@/models/myProfile/Gift';
import Voucher from '@/models/myProfile/Voucher';
import ExternalVoucher from '@/models/myProfile/ExternalVoucher';
import i18n from '@/libs/index';

import Vue from 'vue';
import Toast from 'vue-toastification';
import SiteLicenseInvitation from '../../models/SiteLicenseInvitation';

import ToastComponent from '../../components/ToastComponent.vue';

Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 4,
  newestOnTop: true,
});

export default {
  // GET CLIENT ACCOUNT
  getClientAccount({ commit, state }) {
    if (!state.clientAccountFetched) {
      commit('UPDATE_IS_LOADING', true);
      const headers = {
        Authorization: `Bearer ${state.clientAccount.token}`,
        LangId: state.currentLanguage ? state.currentLanguage.id : null,
      };
      if (!state.profileSettings.isPorta) {
        headers.AppId = state.profileSettings.aId;
      } else {
        headers.ExternalIframe = true;
      }
      axios
        .get(`${process.env.VUE_APP_BASE_CLIENT_URL}client/account`, {
          headers,
        })
        .then((response) => {
          commit('SET_CLIENT_ACCOUNT_IS_LICENSE_MANAGER', response.data.data.isLicenseManager);
          commit('SET_CLIENT_ACCOUNT_EMAIL', response.data.data.emailAddress);
          commit(
            'SET_CLIENT_ACCOUNT_AUTO_RENEWING_ENABLED',
            response.data.data.autoRenewingEnabled,
          );
          commit('SET_CLIENT_ACCOUNT_FETCHED', true);
        })
        .catch((error) => {
          // console.log('ERRORRR', error);
          if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
            const msg = {
              name: 'tonos-logout',
            };
            window.parent.postMessage(msg, '*');
          }
          commit('SET_CLIENT_ACCOUNT_EMAIL', '');
        })
        .finally(() => {
          commit('UPDATE_IS_LOADING', false);
          commit('UPDATE_PAGE_HEIGHT');
        });
    }
  },
  getClientSubscriptionValidity({ commit, state }) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}subscription/validity`, {
        headers,
      })
      .then((response) => {
        commit('SET_ARE_SUBSCRIPTIONS_VALID', response.data.data);
      })
      .catch((error) => {
        // console.log('ERRORRR', error);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_ARE_SUBSCRIPTIONS_VALID', false);
      });
  },
  // GET CLIENT SUBSCRIPTIONS
  getClientActiveSubscriptions({ commit, state }, fade = false) {
    commit('UPDATE_PAGE_HEIGHT');
    const a = document.querySelector('.subscriptions-holder-table');
    if (state.clientAccount.activeSubscriptions.length < 1 && a && !fade) {
      commit('UPDATE_IS_LOADING', true);
      a.style.opacity = '1';
    } else if (a && !fade) {
      a.style.opacity = '0.5';
    }
    // commit('CLEAR_CLIENT_SUBSCRIPTIONS')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}subscription`, {
        headers,
        params: state.activeSubscriptionsSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const subscriptions = data.items.map((x) => new Subscription(x));
        commit('SET_ACTIVE_CLIENT_SUBSCRIPTIONS', subscriptions);
        if (a) a.style.opacity = '1';

        commit('SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        if (a) a.style.opacity = '1';
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_ACTIVE_CLIENT_SUBSCRIPTIONS', []);
        commit('SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_ACTIVE_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES', 0);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        commit('UPDATE_MAIN_IS_LOADING', false);
        setTimeout(() => {
          commit('UPDATE_PORTA_MAIN_IS_LOADING', false);
        }, 200);
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
        }, 100);
      });
  },
  // GET CLIENT SUBSCRIPTIONS
  getClientExpiredSubscriptions({ commit, state }) {
    commit('UPDATE_PAGE_HEIGHT');
    const a = document.querySelector('.subscriptions-holder-table');
    // console.log('AAAAAAAAAAAAAAAAAA', a);
    if (state.clientAccount.expiredSubscriptions.length < 1 && a) {
      commit('UPDATE_IS_LOADING', true);
      a.style.opacity = '1';
    } else if (a) {
      a.style.opacity = '0.5';
    }
    // commit('CLEAR_CLIENT_SUBSCRIPTIONS')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}subscription`, {
        headers,
        params: state.expiredSubscriptionsSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const subscriptions = data.items.map((x) => new Subscription(x));
        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS', subscriptions);
        if (a) a.style.opacity = '1';

        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        if (a) a.style.opacity = '1';
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS', []);
        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_EXPIRED_SUBSCRIPTIONS_PAGINATION_TOTAL_PAGES', 0);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        commit('UPDATE_MAIN_IS_LOADING', false);
        setTimeout(() => {
          commit('UPDATE_PORTA_MAIN_IS_LOADING', false);
        }, 200);
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
        }, 100);
      });
  },
  // REDEEM LICENSE INVITATION
  redeemLicenseInvitation({ dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/redeem-access?invitationId=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_redeemed_access_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_redeemed_access_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
        }
        // eslint-disable-next-line no-undef
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_redeem_access'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_redeem_access'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        dispatch('getSiteLicenseInvitations');
        dispatch('getClientSubscriptions');
      });
  },
  // CANCEL SUBSCRIPTION BY ID
  cancelSubscription({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}subscription/cancel`,
        { subscriptionId: data },
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_subscription_canceled_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_subscription_canceled_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
        }
        // eslint-disable-next-line no-undef
      })
      .catch((error) => {
        // this._vm.$toast.error(i18n.t('client_account_my_account'), {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_subscription_cancelation_failed'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_subscription_cancelation_failed'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        dispatch('getSiteLicenseInvitations');
        dispatch('getClientActiveSubscriptions');
      });
  },

  // ABANDON CANCELLATION OF SUBSCRIPTION BY ID
  async subscriptionAbandonCancellation({ dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    await axios
      .get(
        `${process.env.VUE_APP_BASE_CLIENT_URL}subscription/abandon-subscription-cancelation-request?subscriptionPublicId=${data}`,
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_restart_membership_success'), // Restarted membership successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_restart_membership_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
        // eslint-disable-next-line no-undef
      })
      .catch((error) => {
        // this._vm.$toast.error(i18n.t('client_account_my_account'), {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_restart_membership_failed'), // Failed to restart membership!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_restart_membership_failed'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        dispatch('getSiteLicenseInvitations');
        dispatch('getClientActiveSubscriptions');
      });
  },
  // TOGGLE AUTO RENEWING SUBSCRIPTION
  toggleSubscriptionAutoRenew({ commit, state, dispatch }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .put(
        `${process.env.VUE_APP_BASE_CLIENT_URL}subscription/toggle-autorenew?subscriptionId=${data.id}`,
        {},
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: data.toggleState
                  ? i18n.t('client_account_notification_auto_renew_turn_off_success')
                  : i18n.t('client_account_notification_auto_renew_turn_on_success'), // Auto renew turned off successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: data.toggleState
                ? i18n.t('client_account_notification_auto_renew_turn_off_success')
                : i18n.t('client_account_notification_auto_renew_turn_on_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .catch((error) => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: data.toggleState
                  ? i18n.t('client_account_notification_auto_renew_turn_off_fail')
                  : i18n.t('client_account_notification_auto_renew_turn_on_fail'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: data.toggleState
                ? i18n.t('client_account_notification_auto_renew_turn_off_fail')
                : i18n.t('client_account_notification_auto_renew_turn_on_fail'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        dispatch('getSiteLicenseInvitations', true);
        dispatch('getClientActiveSubscriptions', true);
      });
  },

  // GET CLIENT PAYMENT HISTORY
  getClientPaymentHistory({ commit, state }) {
    const a = document.querySelector('.payments-holder-table');
    if (state.clientAccount.paymentInfo.paymentsHistory?.length < 1) {
      if (a) {
        a.style.opacity = '1';
      }
      commit('UPDATE_IS_LOADING', true);
    } else if (a) {
      a.style.opacity = '0.5';
    }
    commit('UPDATE_PAGE_HEIGHT');
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}payment`, {
        headers,
        params: state.paymentsSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const payments = data.items.map((x) => new Payment(x));
        commit('SET_CLIENT_PAYMENTS_HISTORY', payments);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_COUNT', data.totalCount);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_PAGE_SIZE', data.pageSize);
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_PAYMENTS_HISTORY', []);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_PAGES', 0);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_TOTAL_COUNT', 0);
        commit('SET_CLIENT_PAYMENTS_PAGINATION_PAGE_SIZE', 0);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        commit('UPDATE_IS_LOADING', false);
        commit('UPDATE_MAIN_IS_LOADING', false);
        setTimeout(() => {
          commit('UPDATE_PORTA_MAIN_IS_LOADING', false);
        }, 200);
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.payments-holder-table').style.opacity = '1';
        }, 100);
      });
  },

  addPaymentMethod({ commit, state, dispatch }, paymentMethod) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }

    let endpoint;
    if (typeof paymentMethod === 'string') {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}client/payment/information?paymentMethodNonce=${paymentMethod}`
    } else if (typeof paymentMethod === 'object') {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}stripe/customer/add-payment-method?paymentMethodId=${paymentMethod.paymentMethodId}&currencyId=${paymentMethod.currencyId}`
    }
    axios
      .post(
        endpoint,
        {},
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_payment_method_add_success'), // Payment method added successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_payment_method_add_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
        commit('SET_ADD_PAYMENT_METHOD', false);
        commit('SET_EDIT_PAYMENT_METHOD', false);
        commit('SET_CLIENT_SELECTED_PAYMENT_INFO', {});
        dispatch('getClientPaymentInformation');
        setTimeout(() => {
          dispatch('getClientPaymentInformation');
        }, 2000);
      })
      .catch((error) => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_method_add_fail'), // Failed to add payment method!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_method_add_fail'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('UPDATE_ADD_EDIT_PAYMENT_METHOD_IS_LOADING', false);
      });
  },
  editPaymentMethod({ commit, state, dispatch }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .put(
        `${process.env.VUE_APP_BASE_CLIENT_URL}client/payment/information?paymentMethodToken=${data.paymentMethodToken}&paymentMethodNonce=${data.nonce}`,
        {},
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_payment_method_edit_success'), // Payment method edited successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_payment_method_edit_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }

        commit('SET_ADD_PAYMENT_METHOD', false);
        commit('SET_EDIT_PAYMENT_METHOD', false);
        commit('SET_CLIENT_SELECTED_PAYMENT_INFO', {});
        dispatch('getClientPaymentInformation');
        setTimeout(() => {
          dispatch('getClientPaymentInformation');
        }, 2000);
      })
      .catch((error) => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_method_edit_fail'), // Failed to edit payment method!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_method_edit_fail'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('UPDATE_ADD_EDIT_PAYMENT_METHOD_IS_LOADING', false);
      });
  },
  deletePaymentMethod({ commit, state, dispatch }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }

    let endpoint;
    if (state.clientAccount.paymentInfo.braintreeClientToken !== '') {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}client/payment/information?cardInformationId=${data.id}`;
    } else {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}stripe/customer/payment-method/detach?paymentMethodId=${data.paymentMethodToken}`;
    }

    axios
      .delete(endpoint, {
        headers,
      })
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_payment_method_delete_success'), // Payment method deleted successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_payment_method_delete_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .catch((error) => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_method_delete_fail'), // Failed to delete payment method!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_method_delete_fail'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        commit('SET_CLIENT_SELECTED_PAYMENT_INFO', {});
        dispatch('getClientPaymentInformation');
        setTimeout(() => {
          dispatch('getClientPaymentInformation');
        }, 2000);
      });
  },
  async makeDefaultPaymentMethod({ state, dispatch }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }

    let endpoint;
    if (state.clientAccount.paymentInfo.braintreeClientToken !== '') {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}client/payment/information/make-default?cardInformationId=${data.id}`;
    } else {
      endpoint = `${process.env.VUE_APP_BASE_CLIENT_URL}stripe/customer/payment-method/set-default?paymentMethodId=${data.paymentMethodToken}&currencyId=1`;
    }

    await axios
      .patch(
        endpoint,
        {},
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_payment_method_set_as_default_success'), // Payment method set as default successfully!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_payment_method_set_as_default_success'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }

        dispatch('getClientPaymentInformation');
        setTimeout(() => {
          dispatch('getClientPaymentInformation');
        }, 2000);
      })
      .catch((error) => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_method_set_as_default_fail'), // Failed to set the payment method as default!
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_method_set_as_default_fail'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      });
  },
  // GET CLIENT PAYMENT INFORMATION
  getClientPaymentInformation({ commit, state }) {
    const a = document.querySelector('.payments-holder-table');
    if (state.clientAccount.paymentInfo.paymentInfos?.length < 1 && a) {
      commit('UPDATE_IS_LOADING', true);
      a.style.opacity = '1';
    } else if (a) {
      a.style.opacity = '0.5';
    }
    commit('UPDATE_PAGE_HEIGHT');
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}client/payment/information`, {
        headers,
      })
      .then((response) => {
        // const infos = [
        //   { cardBrand: response.data.data.cardBrand, cardNumber: response.data.data.cardNumber },
        // ];
        const paymentInfos = response.data.data.map((x) => new PaymentInfo(x));
        commit('SET_CLIENT_PAYMENT_INFOS', paymentInfos);
        commit('SET_CLIENT_PAYMENT_INFOS_PAGINATION_CURRENT_PAGE', 1);
        commit('SET_CLIENT_PAYMENT_INFOS_PAGINATION_TOTAL_PAGES', 1);
        commit('SET_CLIENT_PAYMENT_INFOS_PAGINATION_TOTAL_COUNT', 1);
        commit('SET_CLIENT_PAYMENT_INFOS_PAGINATION_PAGE_SIZE', 1);

        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_PAYMENT_INFOS', []);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        document.querySelector('.payments-holder-table').style.opacity = '1';

        commit('UPDATE_MAIN_IS_LOADING', false);
        setTimeout(() => {
          commit('UPDATE_PORTA_MAIN_IS_LOADING', false);
        }, 200);
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
        }, 100);
        const index = state.clientAccount.paymentInfo.paymentInfos.findIndex(
          (x) => x.id === state.clientAccount.paymentInfo.selectedPaymentInfo.id,
        );
        if (index !== -1) {
          state.clientAccount.paymentInfo.paymentInfos.splice(index, 1);
        }
      });
  },
  // GET CLIENT PAYMENT BRAINTREE TOKEN
  getClientPaymentBraintreeToken({ commit, state }) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}client/braintree/token`, {
        headers,
      })
      .then((response) => {
        commit('SET_CLIENT_PAYMENT_INFO_BRAINTREE_CLIENT_TOKEN', response.data.data);
      })
      .catch(() => {
        commit('SET_CLIENT_PAYMENT_INFO_BRAINTREE_CLIENT_TOKEN', null);
      })
      .finally(() => {
        commit('UPDATE_PAGE_HEIGHT');
      });
  },

  getClientPaymentStripeToken({ commit, state }) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}stripe/token`, {
        headers,
      })
      .then((response) => {
        commit('SET_CLIENT_PAYMENT_INFO_STRIPE_CLIENT_TOKEN', response.data.data);
      })
      .catch(() => {
        commit('SET_CLIENT_PAYMENT_INFO_STRIPE_CLIENT_TOKEN', null);
      })
      .finally(() => {
        commit('UPDATE_PAGE_HEIGHT');
      });
  },

  // RETRY PAYMENT PURCHASE
  retryPaymentPurchase({ state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}pap/retry-purchase`,
        { pid: data.pid, returnUrl: data.returnUrl },
        {
          headers,
          params: { paymentId: data },
        },
      )
      .then((response) => {
        const msg = {
          name: 'tonos-retry-purchase',
          gwUrl: response.data.data.gwUrl,
        };
        window.parent.postMessage(msg, '*');
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_retry_failed'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_retry_failed'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      });
  },

  // GET CLIENT PAYMENT RECEIPT PDF
  getClientPaymentReceiptPdf({ state }, data) {
    if (!state.profileSettings.isPorta) {
      this._vm.$toast.info(
        {
          component: ToastComponent,
          props: {
            type: 'info',
            title: i18n.t('client_account_notification_getting_ready_to_download_payment_receipt'),
            date: new Date(),
          },
        },
        {
          position: 'top-right',
          timeout: 7029,
          closeOnClick: false,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: 'button',
          icon: false,
          rtl: false,
        },
      );
    }
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}payment/receipt/pdf`, {
        headers,
        params: { paymentId: `${data}` },
        responseType: 'blob',
      })
      .then((response) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', 'Payment receipt.pdf'); // any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t(
                  'client_account_notification_payment_receipt_downloaded_successfully',
                ),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_payment_receipt_downloaded_successfully'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_payment_receipt_download_failed'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_payment_receipt_download_failed'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      });
  },

  // SEND CLIENT PAYMENT RECEIPT EMAIL
  getClientPaymentReceiptEmail({ state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}payment/receipt/email`, {
        headers,
        params: { paymentId: data },
      })
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_an_email_has_been_sent'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_an_email_has_been_sent'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_send_email'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_send_email'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      });
  },

  // GET LANGUAGE DROPDOWN LIST
  getLanguagesDropdown({ state, commit }) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`${process.env.VUE_APP_BASE_CLIENT_URL}language/dropdown-list`, {
          headers,
          params: {
            take: 20,
          },
        })
        .then((response) => {
          // console.warn('LANGUAGESS', response);
          if (response) {
            commit('SET_LANGUAGES_DROPDOWNLIST', response);
          }
          resolve(response);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
            const msg = {
              name: 'tonos-logout',
            };
            window.parent.postMessage(msg, '*');
          }
          reject(error);
        });
    });
  },
  // GET LANGUAGE LOCALE
  getLanguage({ commit, state }) {
    // commit('UPDATE_MAIN_IS_LOADING', true)
    // commit('UPDATE_MAIN_PAGE_HEIGHT')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    return axios
      .get(
        `${process.env.VUE_APP_BASE_CLIENT_URL}language/account?languageId=${
          state.currentLanguage ? state.currentLanguage.id : null
        }`,
        {
          headers,
        },
      )
      .then((response) => {
        const lang = response.data.data;
        i18n.setLocaleMessage('en', lang);
        commit('SET_LANGUAGE', lang);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        i18n.setLocaleMessage('en', state.profileSettings.language);
      })
      .finally(() => {
        commit('UPDATE_MAIN_IS_LOADING', false);
        // console.log('LANGUAGE IS SET!!');
        // commit('UPDATE_MAIN_PAGE_HEIGHT')
      });
  },

  // get site licenses
  getSiteLicenses({ commit, state }) {
    if (state.clientAccount.siteLicenses.length < 1) {
      commit('UPDATE_IS_LOADING', true);
    } else if (document.querySelector('.site-license-table')) {
      document.querySelector('.site-license-table').style.opacity = '0.5';
    }
    commit('UPDATE_PAGE_HEIGHT');
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}license`, {
        headers,
        params: state.licenseSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const siteLicenses = data.items.map((x) => new SiteLicense(x));
        commit('SET_CLIENT_SITE_LICENSES', siteLicenses);
        commit('SET_CLIENT_SITE_LICENSE_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_SITE_LICENSE_PAGINATION_TOTAL_PAGES', data.totalPages);
        // commit('SET_CLIENT_SITE_LICENSE_PAGINATION_TOTAL_COUNT', data.totalCount)
        // commit('SET_CLIENT_SITE_LICENSE_PAGINATION_PAGE_SIZE', data.pageSize)
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_SITE_LICENSES', []);
        commit('SET_CLIENT_SITE_LICENSE_PAGINATION_CURRENT_PAGE', 1);
        commit('SET_CLIENT_SITE_LICENSE_PAGINATION_TOTAL_PAGES', 1);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.site-license-table').style.opacity = '1';
        }, 100);
      });
  },

  // GET SITE LICENSE INVITATIONS
  getSiteLicenseInvitations({ commit, state }) {
    commit('UPDATE_PAGE_HEIGHT');
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}license/invitations`, {
        headers,
        params: state.licenseInvitationsSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const siteLicenseInvitations = data.items.map((x) => new SiteLicenseInvitation(x));
        commit('SET_CLIENT_SITE_LICENSE_INVITATIONS', siteLicenseInvitations);
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
        }, 100);
      });
  },

  // get site license
  getSiteLicense({ commit, state }, data) {
    commit('UPDATE_PAGE_HEIGHT');
    commit('UPDATE_IS_LOADING', true);
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}license/${data.id}`, {
        headers,
      })
      .then((response) => {
        const resData = response.data.data;
        // const siteLicenses = resData.map((x) => new SiteLicense(x))
        commit('SET_CLIENT_SELECTED_SITE_LICENSE_MEMBERSHIPS_TOTAL', resData.membershipsTotal);
        commit('SET_CLIENT_SELECTED_SITE_LICENSE_MEMBERSHIPS_USED', resData.membershipsUsed);
        commit('SET_CLIENT_SELECTED_SITE_LICENSE_NAME', resData.name);
        // commit('SET_CLIENT_SITE_LICENSES', siteLicenses)
        commit('SET_CLIENT_SELECTED_SITE_LICENSE_ID', resData.id);
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        commit('SET_LICENSE_SELECTED', true);
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
        }, 100);
      });
  },

  // get site license users
  getSiteLicenseUsers({ commit, state }, data) {
    commit('UPDATE_PAGE_HEIGHT');
    if (state.clientAccount.siteLicenseUsers.length < 1) {
      commit('UPDATE_IS_LOADING', true);
    } else {
      document.querySelector('.site-license-users-table').style.opacity = '0.5';
    }
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}license/${data}/members`, {
        headers,
        params: state.licenseUsersSettings.filters.params,
      })
      .then((response) => {
        const resData = response.data.data;
        const siteLicenseUsers = resData.items.map((x) => new SiteLicenseUser(x));
        commit('SET_CLIENT_SITE_LICENSE_USERS', siteLicenseUsers);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_CURRENT_PAGE', resData.currentPage);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_PAGES', resData.totalPages);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_COUNT', resData.totalCount);
        // commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_COUNT', data.totalCount)
        // commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_PAGE_SIZE', data.pageSize)

        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        console.log(error);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_SITE_LICENSE_USERS', []);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_CURRENT_PAGE', 1);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_PAGES', 1);
        commit('SET_CLIENT_SITE_LICENSE_USERS_PAGINATION_TOTAL_COUNT', 0);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.site-license-users-table').style.opacity = '1';
        }, 100);
      });
  },
  // ADD SITE LICENSE USER
  addSiteLicenseUser({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(`${process.env.VUE_APP_BASE_CLIENT_URL}license/add-member`, data, {
        headers,
      })
      .then(() => {
        // commit('SET_CLIENT_SELECTED_SITE_LICENSE_MEMBERSHIPS_USED',
        // (state.licenseSettings.membershipsUsed + 1))
        dispatch('getSiteLicense', { id: state.licenseSettings.selectedLicenseId });
        dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_added_user_successfully'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_added_user_successfully'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
        // eslint-disable-next-line no-undef
      })
      .catch((error) => {
        // this._vm.$toast.error(i18n.t('client_account_my_account'), {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_add_user'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_add_user'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_SHOW_ADD_MEMBER_MODAL', false);
        commit('SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_FIRST_NAME', '');
        commit('SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_LAST_NAME', '');
        commit('SET_CLIENT_SITE_LICENSE_USERS_ADD_MEMBER_INFORMATION_EMAIL_ADDRESS', '');
      });
  },

  revokeUser({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .put(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/users/revoke?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_user_access_revoked_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_failed_to_add_user'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
          dispatch('getSiteLicense', { id: state.licenseSettings.selectedLicenseId });
          dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_revoke_user_access'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_revoke_user_access'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },

  removeInvitation({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }

    axios
      .put(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/users/remove-invitation?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_removed_invitation_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_removed_invitation_successfully'),
              },
            };

            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
          if ((state.licenseUsersSettings.pagination.totalCount - 1) % 7 === 0) {
            if (state.licenseUsersSettings.filters.params.Page > 1) {
              state.licenseUsersSettings.filters.params.Page -= 1;
            }
          }
          dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
          dispatch('getSiteLicense', { id: state.licenseSettings.selectedLicenseId });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_remove_invitation'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_remove_invitation'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },

  remove({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .put(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/users/remove?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_removed_invitation_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_removed_invitation_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
          dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_remove_invitation'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_remove_invitation'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },
  resendInvitation({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/resend-invitation?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        // console.log('respo', response.data);
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_resend_invitation_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_resend_invitation_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
          dispatch('getSiteLicense', { id: state.licenseSettings.selectedLicenseId });
          dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_resend_invitation'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_resend_invitation'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });

        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },
  sendNewInvitation({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/send-new-invitation?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_sent_new_invitation_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_sent_new_invitation_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
          dispatch('getSiteLicense', { id: state.licenseSettings.selectedLicenseId });
          dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_send_new_invitation'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_send_new_invitation'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });

        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },
  removeUser({ commit, dispatch, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}license/users/resend-invitation?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then(() => {
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.success(
            {
              component: ToastComponent,
              props: {
                type: 'success',
                title: i18n.t('client_account_notification_removed_user_successfully'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'success',
              text: i18n.t('client_account_notification_removed_user_successfully'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
        dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_remove_user'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_remove_user'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        dispatch('getSiteLicenseUsers', state.licenseSettings.selectedLicenseId);
        commit('SET_CLIENT_SELECTED_LICENSE_USER_ID', null);
      });
  },

  getGifts({ commit, state }) {
    if (state.clientAccount.gifts.length < 1) {
      commit('UPDATE_IS_LOADING', true);
    } else if (document.querySelector('.gifts-holder-table')) {
      document.querySelector('.gifts-holder-table').style.opacity = '0.5';
    }
    commit('UPDATE_PAGE_HEIGHT');
    // commit('CLEAR_CLIENT_SUBSCRIPTIONS')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}gift`, {
        headers,
        params: state.giftsSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const gifts = data.items.map((x) => new Gift(x));
        commit('SET_CLIENT_GIFTS', gifts);
        commit('UPDATE_IS_LOADING', false);
        commit('SET_CLIENT_GIFTS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_GIFTS_PAGINATION_TOTAL_COUNT', data.totalCount);
        commit('SET_CLIENT_GIFTS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('SET_CLIENT_GIFTS_PAGINATION_PAGE_SIZE', data.pageSize);
      })
      .catch((error) => {
        commit('UPDATE_IS_LOADING', false);
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_SUBSCRIPTIONS', []);
        commit('SET_CLIENT_GIFTS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_GIFTS_PAGINATION_TOTAL_PAGES', 0);
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.gifts-holder-table').style.opacity = '1';
        }, 100);
      });
  },
  getVouchers({ commit, state }) {
    if (state.clientAccount.vouchers.length < 1) {
      commit('UPDATE_IS_LOADING', true);
    } else {
      document.querySelector('.gifts-holder-table').style.opacity = '0.5';
    }

    commit('UPDATE_PAGE_HEIGHT');
    // commit('CLEAR_CLIENT_SUBSCRIPTIONS')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}gift/vouchers`, {
        headers,
        params: state.vouchersSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const vouchers = data.items.map((x) => new Voucher(x));
        commit('SET_CLIENT_VOUCHERS', vouchers);
        commit('UPDATE_IS_LOADING', false);
        // if (a)a.style.opacity = '1'
        commit('SET_CLIENT_VOUCHERS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_VOUCHERS_PAGINATION_TOTAL_COUNT', data.totalCount);
        commit('SET_CLIENT_VOUCHERS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('SET_CLIENT_VOUCHERS_PAGINATION_PAGE_SIZE', data.pageSize);
      })
      .catch((error) => {
        commit('UPDATE_IS_LOADING', false);
        console.error(error);
        // if (a)a.style.opacity = '1'
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_VOUCHERS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_VOUCHERS_PAGINATION_TOTAL_PAGES', 0);
        // commit('UPDATE_IS_LOADING', false)
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.gifts-holder-table').style.opacity = '1';
        }, 100);
      });
  },
  resendGiftEmail({ commit, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}gift/resend-email?id=${data}`,
        {},
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_resend_gift_email_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_resend_gift_email_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title: i18n.t('client_account_notification_failed_to_resend_gift_email'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text: i18n.t('client_account_notification_failed_to_resend_gift_email'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
      })
      .finally(() => {
        commit('SET_CONFIRMATION_MODAL', { show: false, type: null, subscription: null });
        commit('SET_SELECTED_GIFT_ID', null);
      });
  },
  getExternalVouchers({ commit, state }) {
    if (state.clientAccount.externalVouchers.length < 1) {
      commit('UPDATE_IS_LOADING', true);
    } else if (document.querySelector('.gifts-holder-table')) {
      document.querySelector('.gifts-holder-table').style.opacity = '0.5';
    }
    commit('UPDATE_PAGE_HEIGHT');
    // commit('CLEAR_CLIENT_SUBSCRIPTIONS')
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .get(`${process.env.VUE_APP_BASE_CLIENT_URL}add-ons/promotions`, {
        headers,
        params: state.externalVouchersSettings.filters.params,
      })
      .then((response) => {
        const { data } = response.data;
        const externalVouchers = data.items.map((x) => new ExternalVoucher(x));

        commit('SET_CLIENT_EXTERNAL_VOUCHERS', externalVouchers);
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_CURRENT_PAGE', data.currentPage);
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_TOTAL_COUNT', data.totalCount);
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_TOTAL_PAGES', data.totalPages);
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_PAGE_SIZE', data.pageSize);
        commit('UPDATE_IS_LOADING', false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_CURRENT_PAGE', 0);
        commit('SET_CLIENT_EXTERNAL_VOUCHERS_PAGINATION_TOTAL_PAGES', 0);
        commit('UPDATE_IS_LOADING', false);
      })
      .finally(() => {
        setTimeout(() => {
          commit('UPDATE_PAGE_HEIGHT');
          document.querySelector('.gifts-holder-table').style.opacity = '1';
        }, 100);
      });
  },

  sendCustomerSupportMessage({ commit, state }, data) {
    const headers = {
      Authorization: `Bearer ${state.clientAccount.token}`,
      LangId: state.currentLanguage ? state.currentLanguage.id : null,
    };
    if (!state.profileSettings.isPorta) {
      headers.AppId = state.profileSettings.aId;
    } else {
      headers.ExternalIframe = true;
    }
    axios
      .post(
        `${process.env.VUE_APP_BASE_CLIENT_URL}customer-support`,
        {
          message: data,
        },
        {
          headers,
        },
      )
      .then((response) => {
        if (response.data.success) {
          if (!state.profileSettings.isPorta) {
            this._vm.$toast.success(
              {
                component: ToastComponent,
                props: {
                  type: 'success',
                  title: i18n.t('client_account_notification_support_message_send_successfully'),
                  date: new Date(),
                },
              },
              {
                position: 'top-right',
                timeout: 7029,
                closeOnClick: false,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: 'button',
                icon: false,
                rtl: false,
              },
            );
          } else {
            const msg = {
              name: 'toast-notification',
              data: {
                type: 'success',
                text: i18n.t('client_account_notification_support_message_send_successfully'),
              },
            };
            // console.log('MESSAGE PORTA', msg);
            window.parent.postMessage(msg, '*');
          }
        }
        commit('SET_SHOW_CONTACT_SUPPORT_MODAL', false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401 && !state.profileSettings.isPorta) {
          const msg = {
            name: 'tonos-logout',
          };
          window.parent.postMessage(msg, '*');
        }
        if (!state.profileSettings.isPorta) {
          this._vm.$toast.error(
            {
              component: ToastComponent,
              props: {
                type: 'error',
                title:
                  error.response.data.errors.Error && error.response.data.errors.Error[0]
                    ? `${error.response.data.errors.Error[0]}!`
                    : i18n.t('client_account_notification_support_failed_to_send_message'),
                date: new Date(),
              },
            },
            {
              position: 'top-right',
              timeout: 7029,
              closeOnClick: false,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: 'button',
              icon: false,
              rtl: false,
            },
          );
        } else {
          const msg = {
            name: 'toast-notification',
            data: {
              type: 'error',
              text:
                error.response.data.errors.Error && error.response.data.errors.Error[0]
                  ? `${error.response.data.errors.Error[0]}!`
                  : i18n.t('client_account_notification_support_failed_to_send_message'),
            },
          };
          // console.log('MESSAGE PORTA', msg);
          window.parent.postMessage(msg, '*');
        }
        if (error.response.data.errors.Error && error.response.data.errors.Error[0]) {
          commit('SET_SHOW_CONTACT_SUPPORT_MODAL', false);
        }
      })
      .finally(() => {
        commit('SET_CONTACT_SUPPORT_BUTTON_DISABLED', false);
      });
  },
};
